import type { ComponentPublicInstance } from 'vue';

/**
 * Hides a Quasar QPopupProxy ref by name.
 * Used across many components with q-date/q-time popup proxies.
 */
export function hidePopupProxy(
  // Only $refs is used; typing just that lets components with a typed
  // `emits` option pass `this` too.
  vm: Pick<ComponentPublicInstance, '$refs'>,
  refName: string
): void {
  (vm.$refs[refName] as any)?.hide();
}
